/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Carriage.scss";
import topImage from "../../../Cartesian/Assets/top.JPG";
import upsideDownImage from "../../../Cartesian/Assets/upside_down.JPG";
import sideImage from "../../../Cartesian/Assets/side.JPG";
import t from "../../../Common/utils/translation/translator";
import { selectMechanics, setMechanics } from "../../store/slices/cartesian";
import { CARRIAGE_ORIENTATIONS, orientationToDisplayString } from "../../store/data/cartesianData";

const CarriageOrientationGridItem = ({ orientation, handleChange, id, name, image, ...props }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setIsLoading(false);
    img.src = image;
  }, [image]);

  return (
    <div
      className="CarriageOrientationGridItem flex-1 flex flex-col items-center justify-center space-y-2 cursor-pointer group"
      onClick={() => {
        handleChange({ target: { id } });
      }}
      {...props}
    >
      <div />
      {isLoading ? (
        <div className="h-20 w-20 animate-pulse bg-gray-100 rounded" />
      ) : (
        <img
          src={image}
          alt={id}
          className="h-20 border-2 border-transparent rounded group-hover:border-primary transition-all duration-100"
        />
      )}
      <div className="carriage-typography-choose group-hover:font-semibold transition-all duration-100">{name}</div>
      <input
        type="radio"
        checked={orientation === id}
        id={id}
        name="carriageOrientation"
        className="group-hover:border-2 group-hover:border-primary transition-all duration-100"
        onChange={() => {}}
      />
    </div>
  );
};

const CarriageOrientation = ({ ...props }) => {
  const dispatch = useDispatch();
  const mechanics = useSelector(selectMechanics);

  const handleChange = (event) => {
    const newOrientation = event.target.id;
    let newAxisAngle = mechanics?.axisAngle;
    if (newOrientation === CARRIAGE_ORIENTATIONS.upSideDown) {
      newAxisAngle = 180;
    }
    if (newOrientation === CARRIAGE_ORIENTATIONS.top || newOrientation === CARRIAGE_ORIENTATIONS.onTheSide) {
      newAxisAngle = 0;
    }
    const newData = { ...mechanics, carriageOrientation: newOrientation, axisAngle: newAxisAngle };
    dispatch(setMechanics(newData));
  };

  return (
    <div className="CarriageOrientation my-4" {...props}>
      <div className="carriage-typography">
        {t("cartesian.ui.mechanics.carriage_orientation")}
        <span className="light-error-active">*</span>
      </div>
      <div className="carriage-typography-choose">{t("cartesian.ui.mechanics.carriage_orientation_choice")}</div>
      {/* className=carriage-flex-container */}
      <div className="grid-container-orientation flex">
        <CarriageOrientationGridItem
          data-testid={`carriage-orientation-grid-item-${CARRIAGE_ORIENTATIONS.top}`}
          orientation={mechanics.carriageOrientation}
          handleChange={handleChange}
          id={CARRIAGE_ORIENTATIONS.top}
          name={orientationToDisplayString(CARRIAGE_ORIENTATIONS.top)}
          image={topImage}
        />
        <CarriageOrientationGridItem
          data-testid={`carriage-orientation-grid-item-${CARRIAGE_ORIENTATIONS.upSideDown}`}
          orientation={mechanics.carriageOrientation}
          handleChange={handleChange}
          id={CARRIAGE_ORIENTATIONS.upSideDown}
          name={orientationToDisplayString(CARRIAGE_ORIENTATIONS.upSideDown)}
          image={upsideDownImage}
        />
        <CarriageOrientationGridItem
          data-testid={`carriage-orientation-grid-item-${CARRIAGE_ORIENTATIONS.onTheSide}`}
          orientation={mechanics.carriageOrientation}
          handleChange={handleChange}
          id={CARRIAGE_ORIENTATIONS.onTheSide}
          name={orientationToDisplayString(CARRIAGE_ORIENTATIONS.onTheSide)}
          image={sideImage}
        />
      </div>
    </div>
  );
};
export default CarriageOrientation;
